import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
  ViewEncapsulation
} from '@angular/core';
import { TranslocoService } from '@jsverse/transloco';

import { isNullOrUndefined } from '@app/util/util';
import { OptionSelected } from '@booking/entities/booking-arrangement';

@Component({
  selector: 'app-search-bar-child-ages',
  templateUrl: './search-bar-child-ages.component.html',
  styleUrls: ['./search-bar-child-ages.component.sass'],
  encapsulation: ViewEncapsulation.ShadowDom,
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class SearchBarChildAgesComponent {

  @Input() childrenQuantity: number;
  @Input() childrenAges: number[];
  @Input() idSelector: string;
  @Input() isMobile: boolean;

  @Output() emitAgeSelection: EventEmitter<OptionSelected> = new EventEmitter<OptionSelected>();

  public toggleSelector: boolean = false;
  public toggleItem: number | null = null;
  public minAge: number = 0;
  public maxAge: number = 11;
  public toggleIsShow: boolean;

  constructor(
    private readonly transloco: TranslocoService
  ) { }

  get ages(): string[] {
    return Array.from({ length: this.maxAge - this.minAge + 1 }, (v, k) => {
      const age = k + this.minAge;
      return this.transloco.translate(this.ageLabel(age), { age });
    })
  }

  get lessThan1YearMessage(): string {
    return this.transloco.translate('SEARCH_MODULE.CHILDREN.LESS_THAN_1_YEAR');
  }

  public ageLabel(age: number): string {
    return age === 0 ? 'SEARCH_MODULE.CHILDREN.LESS_THAN_1_YEAR' : age === 1 ?
      'SEARCH_MODULE.CHILDREN.AGE' : 'SEARCH_MODULE.CHILDREN.AGES';
  }

  public inAges(id: number): boolean {
    return !!this.childrenAges && !isNullOrUndefined(this.childrenAges[id]);
  }

  public childAge(id: number): string {
    return this.ages[`${id}`];
  }

  public isActive(id: number): boolean {
    return this.toggleSelector && id === this.toggleItem;
  }

  public isDisabled(id: number): boolean {
    return this.toggleSelector && !isNullOrUndefined(this.toggleItem) && id !== this.toggleItem;
  }

  public toggle(id: number): void {
    if (!this.isDisabled(id)) {
      this.toggleSelector = !this.toggleSelector;
      this.toggleItem = this.toggleSelector ? id : null;
    }
  }

  public ageSelection(selection: OptionSelected, index: number): void {
    this.emitAgeSelection.emit({
      index,
      value: selection.value === this.lessThan1YearMessage ? 0 : selection?.value?.toString()?.replace(/^\D+/g, '')
    });
    this.toggle(this.toggleItem);
  }

  public close(): void {
    this.toggleSelector = !this.toggleSelector;
  }

  public trackById(index: number, item: string): string {
    return `${index}-${item}`;
  }

  public defaultAgeValue(id: number): string | null {
    const ageNumber = this.inAges(id) ? this.childrenAges[id] : null;
    return !isNullOrUndefined(ageNumber) ? this.transloco.translate(this.ageLabel(ageNumber), { age: ageNumber }) : null;
  }

  public toggleShow(toggle: boolean): void {
    this.toggleIsShow = toggle;
  }

}
